export default __webpack_public_path__ + "static/media/Massacre.2f0a4295.jpg";